"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateBody = void 0;
var _zod = require("zod");
// the schema defined for the shopper context possible fields
const dataSchema = _zod.z.object({
  deviceType: _zod.z.string(),
  screenSize: _zod.z.string().optional()
});
const validator = inputs => dataSchema.parse(inputs);
const validateBody = config => (req, res, next) => {
  if (req !== null && req !== void 0 && req.body) {
    try {
      if (validator(req.body)) {
        return next();
      }
    } catch (error) {
      res === null || res === void 0 ? void 0 : res.status(400);
      throw new Error(config !== null && config !== void 0 && config.isProduction ? 'The request is malformed' : (error === null || error === void 0 ? void 0 : error.message) || error);
    }
  }
  res === null || res === void 0 ? void 0 : res.status(400);
  throw new Error('The body is missing');
};
exports.validateBody = validateBody;